<template>
  <div class="row">
    <div class="col-12 card" v-if="!postRequest">
      <div class="row justify-content-space-between top-24">
        <h4 class="col-6 card-title">Редактировать заявку на приём отходов</h4>
        <div class="col-6 align-self-end right">
          <button class="col-4 btn-cancel-order" @click="$router.push('/')">Отменить</button>
          <button class="col-4 btn-primary-confirm" v-on:click="createOrder" :disabled="isDisabled">Сохранить</button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 top-24">
          <div class="text-field">
            <label class="text-field__label" for="search">Предполагаемая дата заезда</label>
            <div class="text-field__icon">
              <input
                class="text-field__input"
                type="date"
                v-model="datefilter"
              />
              <div class="alert" v-if="!this.datefilter">Необходимо заполнить</div>
            </div>
          </div>
        </div>
        <div class="col-12 top-24">
          <div class="text-field">
            <label class="text-field__label" for="search">ФИО водителя</label>
            <div class="text-field__icon">
              <input class="text-field__input" type="search" name="search" id="search" placeholder="Иванов Иван Иванович" v-model="this.OrderDriver">
              <div class="alert" v-if="!this.OrderDriver">Необходимо заполнить</div>
            </div>
          </div>
        </div>
        <div class="col-12 top-24">
          <div class="text-field">
            <label class="text-field__label" for="search">Государственный регистрационный номер</label>
            <div class="row">
              <div class="text-field__icon col-8">
                <div class="row mb-2">
                  <button
                      class="col-6 btn-tab"
                      :class="{ 'btn-tab-active': !manualInput }"
                      @click="toggleInputMode(false)"
                  >
                    Выбрать из списка
                  </button>
                  <button
                      class="col-6 btn-tab"
                      :class="{ 'btn-tab-active': manualInput }"
                      @click="toggleInputMode(true)"
                  >
                    Ввести вручную
                  </button>
                </div>

                <select
                    class="text-field__input"
                    id="car-select"
                    v-model="selectedCar"
                    v-if="!manualInput && wasteCars && wasteCars.length"
                    @change="onCarSelect"
                >
                  <option value="" disabled selected>Выберите автомобиль</option>
                  <option v-for="car in wasteCars" :value="car">{{ car.CarNumber }}</option>
                </select>

                <div v-if="manualInput">
                  <input
                      class="text-field__input"
                      :class="{ 'error': !isValid && orderCar }"
                      type="text"
                      name="carNumber"
                      placeholder="А 125 АА 152"
                      v-model="orderCar"
                      @input="formatCarNumber"
                      @blur="validateCarNumber"
                      maxlength="13"
                  >
                  <div v-if="!isValid && orderCar" class="error-message">
                    Неверный формат номера. Пример: А 123 БЦ 78 или А 123 БЦ 178
                  </div>
                </div>

                <div v-if="!manualInput && (!wasteCars || !wasteCars.length)" class="alert">
                  Нет доступных автомобилей. Добавьте автомобиль или переключитесь на ручной ввод.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 top-24">
          <div class="text-field">
            <label class="text-field__label" for="search">Номер договора</label>
            <div class="text-field__icon">
              <select class="text-field__input" id="standard-select" v-model="ContractID" @change="onContractChange">
                <option value="" disabled selected>Выберите договор</option>
                <option v-for="contract in activeContracts" :key="contract.ContractID" :value="contract">
                  {{ contract.ContractID }}, остаток: {{ contract.Amount }}
                </option>
              </select>
              <div class="alert" v-if="!this.ContractID">Необходимо заполнить</div>
            </div>
          </div>
        </div>

        <div class="col-12" v-if="this.ContractID && this.ContractID.Amount == 0">
          <div class="text-field">
            <label class="text-field__label" style="color:chocolate">Остаток по договору равен 0, необходимо пополнить счет</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 top-24">
            <div class="text-field">
              <label class="text-field__label col-12 top-24">Добавить вид отхода</label>
              <div class="row align-items-center waste-type-row">
                <div class="col-8">
                  <div v-if="this.ContractID && this.ContractID.WasteTypes">
                    <CustomDropdown
                        v-model="selectedWaste"
                        :options="availableWasteTypes"
                        :disabled="!isWasteSelectionEnabled"
                        placeholder="Выберите вид отхода..."
                        @select="addWasteName"
                        @add="onWasteAdd"
                    />
                    <div
                        v-if="!isWasteSelectionEnabled"
                        class="waste-overlay"
                        @click.prevent="focusContract"
                        title="Сначала выберите договор"
                    ></div>
                  </div>
                  <div v-else>
                    <CustomDropdown
                        v-model="selectedWaste"
                        :options="this.ContractID?.WasteTypes || wasteTypeList"
                        placeholder="Выберите вид отхода..."
                        @select="addWasteName"
                        @add="onWasteAdd"
                    />
                  </div>
                </div>
<!--                <div class="col-4">-->
<!--                  <button class="btn-primary waste-add-btn" v-on:click="addWasteType">-->
<!--                    <span class="icon-Plus"></span>Добавить отход-->
<!--                  </button>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 top-24" v-if="wasteTypes.length">
          <div class="text-field">
            <label class="text-field__label" for="search">Укажите соотношение вывозимых отходов</label>
            <div v-if="!isSumValid" class="alert" style="color: red; margin-bottom: 10px;">
              Сумма процентов должна равняться 100%. Текущая сумма: {{ totalPercent.toFixed(3) }}%
            </div>
            <div v-else class="success-message" style="color: green; margin-bottom: 10px;">
              Сумма процентов: {{ totalPercent.toFixed(3) }}% ✓
            </div>
            <div v-if="wasteTypes.length === 3" class="info-message" style="color: blue; margin-bottom: 10px;">
              Три вида отхода - ручной ввод процентов
            </div>
            <div v-if="hasZeroPercent" class="alert" style="color: red; margin-bottom: 10px;">
              Все виды отходов должны иметь процентное значение больше 0%
            </div>
            <div class="table-responsive">
              <table class="col-12 waste-table" border="1">
                <thead>
                <tr>
                  <th class="width-50">Вид отхода</th>
                  <th class="width-35">Процент</th>
                  <th class="width-15">Действия</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(waste, idx) in wasteTypes" :key="waste.name">
                  <td class="waste-name-cell">{{ waste.name }}</td>
                  <td class="waste-percent-cell">
                    <div class="percent-inputs-wrapper">
                      <input
                          type="range"
                          v-model.number="waste.percent"
                          min="0"
                          max="100"
                          step="0.001"
                          @input="onPercentInput(idx)"
                          :class="{ 'error': !isSumValid }"
                          :disabled="wasteTypes.length === 1"
                          class="range-input"
                      />
                      <div class="number-input-group">
                        <input
                            type="number"
                            v-model.number="waste.percent"
                            min="0"
                            max="100"
                            step="0.001"
                            @input="onPercentInput(idx)"
                            :class="{ 'error': !isSumValid }"
                            :disabled="wasteTypes.length === 1"
                            class="number-input"
                        />
                        <span class="percent-symbol">%</span>
                      </div>
                    </div>
                  </td>
                  <td class="waste-action-cell">
                    <button @click="removeWasteType(idx)" class="btn-remove">Удалить</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 card" v-if="postRequest">
      <div class="row justify-content-space-between top-24">
        <h4 class="col-6 card-title" v-if="!postError">Заявка на рейс на полигон успешно обновлена!</h4>
        <h4 class="col-6 card-title" v-else>Произошла ошибка! {{ this.alert }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CustomDropdown from "@/components/Shared/CustomDropdown.vue";
import moment from 'moment'

export default {
  components: { CustomDropdown },
  data() {
    return {
      title: "Редактировать рейс на полигон",
      datefilter: this.today_date(),
      OrderID: '',
      OrderDriver: '',
      OrderCar: '',
      selectedCar: null,
      manualInput: false,
      orderCar: '',
      isValid: true,
      postError: '',
      alert: '',
      postRequest: false,
      ContractID: '',
      filterText: '',
      selectedWaste: '',
      wasteff: '',
      wasteTypes: [],
      isInitialLoad: true,
      pendingWasteTypes: null,
      pendingWasteProcents: null
    }
  },
  watch: {
    ContractID(newVal, oldVal) {
      console.log('ContractID changed:', oldVal?.ContractID, '->', newVal?.ContractID);

      // При начальной загрузке (редактировании заявки)
      if (this.isInitialLoad) {
        console.log('Начальная загрузка, не очищаем отходы');
        // Если были отложенные виды отходов и договор установлен, загружаем их
        if (newVal && this.pendingWasteTypes) {
          console.log('Загружаем отложенные виды отходов при начальной загрузке');
          this.loadPendingWasteTypes();
        }
        return;
      }

      // При обычной работе (не начальная загрузка)
      if (oldVal && newVal && oldVal.ContractID !== newVal.ContractID) {
        console.log('Очищаем отходы из-за изменения договора');
        this.clearWasteSelection();
      }

      // Если были отложенные виды отходов, загружаем их
      if (newVal && this.pendingWasteTypes) {
        this.loadPendingWasteTypes();
      }
    }
  },
  computed: {
    availableWasteTypes() {
      if (!this.ContractID) {
        return [];
      }
      if (this.ContractID && this.ContractID.WasteTypes && this.ContractID.WasteTypes.length > 0) {
        return this.ContractID.WasteTypes;
      }
      return this.wasteTypeList;
    },
    activeContracts() {
      if (!this.Contracts) return [];
      return this.Contracts.filter(contract => contract.ContractStatus === "true");
    },
    isWasteSelectionEnabled() {
      return !!this.ContractID;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    Contracts() {
      return this.$store.state.polygon_company.Contracts
    },
    wasteCars() {
      return this.$store.state.waste_cars["Cars"]
    },
    wasteTypeList () {
      return this.$store.state.waste_types;
    },
    totalPercent() {
      return this.wasteTypes.reduce((sum, w) => sum + w.percent, 0);
    },
    isSumValid() {
      const sum3 = Number(this.totalPercent.toFixed(3));
      return Math.abs(sum3 - 100) <= 0.0001;
    },
    // filteredWasteTypes() {
    //   const term = this.filterText.trim().toLowerCase();
    //   if (!term) return this.wasteTypeList;
    //   return this.wasteTypeList.filter(type =>
    //       type.toLowerCase().includes(term)
    //   );
    // },
    hasZeroPercent() {
      return this.wasteTypes.some(w => w.percent === 0);
    },
    isDisabled() {
      const isFormValid = this.datefilter &&
          this.OrderCar &&
          this.OrderDriver &&
          this.ContractID &&
          this.wasteTypes.length > 0;

      return !(isFormValid && this.isSumValid && !this.hasZeroPercent);
    }
  },
  mounted() {
    const {
      previous_OrderID,
      previous_OrderDate,
      previous_OrderCar,
      previous_OrderDriver,
      previous_OrderContract,
      previous_WasteTypes,
      previous_WasteProcents
    } = this.$route.query;

    console.log('EditOrder mounted - Параметры из query:', {
      previous_OrderContract,
      previous_WasteTypes,
      previous_WasteProcents
    });

    Promise.all([
      this.$store.dispatch("fetchWasteTypes"),
      this.$store.dispatch("fetchPolygonContracts", this.currentUser.company_inn),
      this.$store.dispatch("fetchWasteCars", this.currentUser.company_inn)
    ]).then(() => {
      if (previous_OrderID) {
        this.OrderID = previous_OrderID;
      }

      if (previous_OrderCar) {
        this.OrderCar = previous_OrderCar;
        this.orderCar = this.formatCarNumberFromClean(previous_OrderCar);

        // Автоматически определяем режим ввода
        if (this.wasteCars && this.wasteCars.length) {
          const existingCar = this.wasteCars.find(car => car.CarNumber === previous_OrderCar);
          if (existingCar) {
            this.selectedCar = existingCar;
            this.manualInput = false;
          } else {
            this.manualInput = true;
          }
        } else {
          this.manualInput = true;
        }
      }

      if (previous_OrderDriver) {
        this.OrderDriver = previous_OrderDriver;
      }

      if (previous_OrderDate) {
        this.datefilter = previous_OrderDate;
      }

      // Обработка договора
      if (previous_OrderContract && this.Contracts) {
        console.log('Ищем договор:', previous_OrderContract, 'в списке:', this.Contracts);
        const contractObj = this.Contracts.find(
            c => c.ContractID === previous_OrderContract
        );
        if (contractObj) {
          console.log('Договор найден:', contractObj);
          this.ContractID = contractObj;
        } else {
          console.log('Договор НЕ найден! Доступные договоры:', this.Contracts?.map(c => c.ContractID));
        }
      }

      if (previous_OrderContract) {
        const decodedContract = previous_OrderContract;
        console.log('Ищем договор:', decodedContract, 'в активных договорах:', this.activeContracts);
        const contract = this.activeContracts?.find(c => c.ContractID === decodedContract);
        if (contract) {
          console.log('Договор найден:', contract);
          this.ContractID = contract;
        } else {
          console.log('Договор НЕ найден или не активен! Доступные активные договоры:',
              this.activeContracts?.map(c => c.ContractID));
        }
      }

      // Обработка видов отходов - сохраняем в pending если договор не установлен
      if (previous_WasteTypes) {
        this.pendingWasteTypes = previous_WasteTypes;
        this.pendingWasteProcents = previous_WasteProcents;

        if (this.ContractID) {
          // Если договор уже установлен, загружаем виды отходов сразу
          this.loadPendingWasteTypes();
        } else {
          console.log('Договор не установлен, виды отходов сохранены в pending');
        }
      }

      // Завершаем начальную загрузку
      this.$nextTick(() => {
        this.isInitialLoad = false;
        console.log('Начальная загрузка завершена');
      });
    });
  },
  methods: {
    loadPendingWasteTypes() {
      if (!this.pendingWasteTypes) return;

      console.log('Загружаем отложенные виды отходов:', this.pendingWasteTypes);

      let wasteTypesArray = Array.isArray(this.pendingWasteTypes)
          ? this.pendingWasteTypes
          : [this.pendingWasteTypes];

      let wastePercentsArray = [];
      if (this.pendingWasteProcents) {
        wastePercentsArray = Array.isArray(this.pendingWasteProcents)
            ? this.pendingWasteProcents.map(p => Number(Number(p).toFixed(3)))
            : [Number(Number(this.pendingWasteProcents).toFixed(3))];
      }

      this.wasteTypes = wasteTypesArray.map((name, i) => ({
        name: name.replace(/^\d+\s+/, '').trim(),  // Удаляем код ФККО из начала строки
        percent: wastePercentsArray[i] ?? 0
      }));

      console.log('Виды отходов загружены:', this.wasteTypes);

      // Если все проценты 0, распределяем автоматически
      const allZero = this.wasteTypes.every(w => w.percent === 0);
      if (allZero) {
        this.distributePercentages();
      }

      // Очищаем pending
      this.pendingWasteTypes = null;
      this.pendingWasteProcents = null;
    },
    focusContract() {
      const select = document.getElementById('standard-select');
      if (select) {
        select.focus();
        select.classList.add('highlight-contract');
        setTimeout(() => {
          select.classList.remove('highlight-contract');
        }, 2200);
      }
    },
    onWasteAdd(opt) {
      this.addWasteName(opt);
      this.addWasteType();
    },
    toggleInputMode(isManual) {
      this.manualInput = isManual;
      if (!isManual) {
        this.orderCar = '';
        this.isValid = true;
        if (this.selectedCar) {
          this.OrderCar = this.selectedCar.CarNumber;
        }
      } else {
        this.selectedCar = null;
      }
    },
    onCarSelect() {
      if (this.selectedCar) {
        this.OrderCar = this.selectedCar.CarNumber;
        this.orderCar = this.formatCarNumberFromClean(this.OrderCar);
      }
    },
    formatCarNumber(event) {
      const input = event.target.value;
      // Убираем пробелы для обработки
      let clean = input.replace(/\s/g, '').toUpperCase();

      // Допустимые буквы для госномера
      const validLetters = 'АВЕКМНОРСТУХ';

      // Строим чистый номер по позициям
      let result = '';
      for (let i = 0; i < clean.length && result.length < 9; i++) {
        const char = clean[i];
        const pos = result.length;

        // Позиции 0, 4, 5 - только допустимые буквы
        if (pos === 0 || pos === 4 || pos === 5) {
          if (validLetters.includes(char)) {
            result += char;
          }
        }
        // Позиции 1, 2, 3, 6, 7, 8 - только цифры
        else if (pos === 1 || pos === 2 || pos === 3 || pos === 6 || pos === 7 || pos === 8) {
          if (/\d/.test(char)) {
            result += char;
          }
        }
      }

      // Форматируем с пробелами: А 123 БВ 78
      let formatted = '';
      for (let i = 0; i < result.length; i++) {
        if (i === 1 || i === 4 || i === 6) formatted += ' ';
        formatted += result[i];
      }

      this.orderCar = formatted;
      this.OrderCar = result;
      this.validateCarNumber();
    },
    formatCarNumberFromClean(cleanNumber) {
      let formatted = '';
      for (let i = 0; i < cleanNumber.length; i++) {
        if (i === 1 || i === 4 || i === 6) formatted += ' ';
        formatted += cleanNumber[i];
      }
      return formatted;
    },
    validateCarNumber() {
      const clean = this.OrderCar;
      if (clean.length === 0) {
        this.isValid = true;
        return;
      }

      const pattern = /^[АВЕКМНОРСТУХ]\d{3}[АВЕКМНОРСТУХ]{2}\d{2,3}$/;
      this.isValid = pattern.test(clean);

      if (this.isValid) {
        const digits = clean.match(/\d+/g);
        if (digits && digits[0] === '000') {
          this.isValid = false;
        }
      }
    },
    format_date(value, time='NaN'){
      if (value) {
        if (time != 'NaN') {
          return moment(String(value)).format('DD.MM.YYYY')
        } else {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    },
    today_date(){
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async createOrder() {
      if (!this.OrderDriver.trim() || !this.OrderCar.trim()) {
        this.postRequest = true;
        this.postError = true;
        this.alert = 'Не заполнено поле с ФИО водителя или номер автомобиля.';
        return;
      }

      if (this.wasteTypes.length === 0) {
        this.postRequest = true;
        this.postError = true;
        this.alert = "Добавьте хотя бы один вид отходов";
        return;
      }

      if (!this.isSumValid) {
        this.postRequest = true;
        this.postError = true;
        this.alert = `Сумма процентов должна быть 100%, сейчас ${this.totalPercent.toFixed(3)}%`;
        return;
      }
      if (this.hasZeroPercent) {
        this.postRequest = true;
        this.postError = true;
        this.alert = 'Все виды отходов должны иметь процентное значение больше 0%';
        return;
      }

      const typesArray = this.wasteTypes.map(w => w.name);
      const percentsArray = this.wasteTypes.map(w => Number(w.percent).toFixed(3));
      const payload = {
        OrderID: this.OrderID,
        CompanyINN: this.currentUser.company_inn[0],
        OrderDate: this.datefilter,
        OrderCar: this.OrderCar.toLowerCase().replace(/\s+/g, ""),
        OrderDriver: this.OrderDriver,
        ContractID: this.ContractID.ContractID,
        WasteTypes: typesArray,
        WasteProcents: percentsArray
      };

      this.postRequest = true;

      try {
        const response = await axios.post(
            `${this.$store.state.domain}/api/polygon/edit_order`,
            payload
        );
        this.postError = false;

        // Сохраняем данные о договоре и отходах для последующего копирования
        const orderData = {
          OrderID: this.OrderID,
          ContractID: this.ContractID.ContractID,
          WasteTypes: typesArray,
          WasteProcents: percentsArray,
          timestamp: Date.now()
        };

        // Получаем существующие данные из localStorage
        const savedOrders = JSON.parse(localStorage.getItem('orderDetails') || '{}');
        savedOrders[this.OrderID] = orderData;

        // Удаляем старые записи (старше 30 дней)
        const thirtyDaysAgo = Date.now() - (365 * 24 * 60 * 60 * 1000);
        Object.keys(savedOrders).forEach(key => {
          if (savedOrders[key].timestamp < thirtyDaysAgo) {
            delete savedOrders[key];
          }
        });

        localStorage.setItem('orderDetails', JSON.stringify(savedOrders));
        console.log('Saved order details to localStorage:', orderData);

        // Обновляем список заявок после редактирования
        await this.$store.dispatch("fetchPolygonOrders", {
          inn: this.currentUser.company_inn,
          start_date: "2024-01-01",
          end_date: new Date().toISOString().split('T')[0]
        });

        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      } catch (err) {
        this.postError = true;
        console.error("Ошибка при редактировании заявки:", err);
      }
    },
    addWasteName(selectedOption) {
      let name = typeof selectedOption === 'string'
          ? selectedOption
          : selectedOption.WasteName || selectedOption.label || selectedOption.text || selectedOption.name || '';

      // Удаляем код ФККО (цифры в начале и пробелы после них)
      // Например: "81210101724   Древесные отходы" -> "Древесные отходы"
      name = name.replace(/^\d+\s+/, '').trim();

      this.wasteff = { name, percent: 0 };
    },
    addWasteType() {
      if (!this.wasteff || !this.wasteff.name) return;
      if (this.wasteTypes.some(w => w.name === this.wasteff.name)) {
        alert('Этот вид отхода уже добавлен');
        return;
      }

      this.wasteTypes.push({
        name: this.wasteff.name,
        percent: 0
      });

      this.distributePercentages();
      this.selectedWaste = '';
    },
    removeWasteType(idx) {
      this.wasteTypes.splice(idx, 1);
      this.distributePercentages();
    },
    distributePercentages() {
      const count = this.wasteTypes.length;

      if (count === 0) return;

      if (count === 1) {
        this.wasteTypes[0].percent = 100;
      } else if (count === 2) {
        const hasZeroPercent = this.wasteTypes.some(w => w.percent === 0);
        if (hasZeroPercent) {
          this.wasteTypes.forEach(waste => {
            waste.percent = 50;
          });
        }
      } else if (count >= 3) {
        const hasZeroPercent = this.wasteTypes.some(w => w.percent === 0);
        if (hasZeroPercent) {
          // Более точное распределение
          const equalPercent = 100 / count;
          this.wasteTypes.forEach((waste, index) => {
            if (index === count - 1) {
              // Для последнего элемента вычисляем остаток
              const previousSum = this.wasteTypes.slice(0, count - 1)
                  .reduce((sum, w) => sum + (w.percent || 0), 0);
              waste.percent = Number((100 - previousSum).toFixed(3));
            } else {
              waste.percent = Number(equalPercent.toFixed(3));
            }
          });
        }
      }
    },
    onPercentInput(idx) {
      const w = this.wasteTypes[idx];
      w.percent = Math.min(100, Math.max(0, w.percent));
      w.percent = Math.round(w.percent * 1000) / 1000;

      if (this.wasteTypes.length >= 3) {
        return;
      }

      if (this.wasteTypes.length === 1) {
        w.percent = 100;
        return;
      }

      if (this.wasteTypes.length === 2) {
        const otherIdx = idx === 0 ? 1 : 0;
        this.wasteTypes[otherIdx].percent = 100 - w.percent;
        this.wasteTypes[otherIdx].percent = Math.round(this.wasteTypes[otherIdx].percent * 1000) / 1000;

        if (this.wasteTypes[otherIdx].percent < 0) {
          this.wasteTypes[otherIdx].percent = 0;
          w.percent = 100;
        } else if (this.wasteTypes[otherIdx].percent > 100) {
          this.wasteTypes[otherIdx].percent = 100;
          w.percent = 0;
        }
      }
    },
    onContractChange() {
      console.log('Договор изменен вручную пользователем');
      // Не очищаем отходы при начальной загрузке
      if (!this.isInitialLoad) {
        console.log('Очищаем отходы т.к. это не начальная загрузка');
        this.clearWasteSelection();
      }
    },
    clearWasteSelection() {
      console.log('Очищаем выбранные отходы. Было:', this.wasteTypes.length, 'отходов');
      this.selectedWaste = '';
      this.wasteff = '';
      this.wasteTypes = [];
      console.log('После очистки:', this.wasteTypes.length, 'отходов');
    },
  }
};
</script>

<style scoped>
.alert {
  color: red;
}
.error {
  border-color: #ff4444 !important;
}
.error-message {
  color: #ff4444;
  font-size: 12px;
  margin-top: 5px;
}
.success-message {
  color: green;
  font-size: 14px;
  font-weight: bold;
}
.info-message {
  color: blue;
  font-size: 14px;
  font-weight: bold;
}
.btn-primary:disabled {
  background-color: #7a7979;
  color: #fff;
  opacity: 1;
  cursor: not-allowed;
}
.waste-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  cursor: not-allowed;
  background: rgba(255,255,255,0.001);
}

/* краткая подсветка селекта договора при клике на оверлей */
.highlight-contract {
  box-shadow: 0 0 0 3px rgba(255,165,0,0.35); /* мягкий оранжевый свет */
  transition: box-shadow 0.2s ease-in-out;
}

/* Waste table styles */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0;
  padding: 0;
}

.waste-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 100%;
  margin: 0;
}

.waste-name-cell {
  word-break: break-word;
  word-wrap: break-word;
  white-space: normal;
  padding: 8px;
  overflow-wrap: break-word;
  max-width: 100%;
}

.waste-percent-cell {
  padding: 8px;
  min-width: 200px;
}

.percent-inputs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: stretch;
}

.range-input {
  width: 100%;
  margin: 0;
}

.number-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.number-input {
  width: 100%;
  max-width: 120px;
  min-width: 80px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  text-align: center;
  box-sizing: border-box;
}

.percent-symbol {
  font-size: 14px;
  color: #666;
}

.waste-action-cell {
  padding: 8px;
  text-align: center;
  white-space: nowrap;
}

.btn-remove {
  padding: 6px 12px;
  font-size: 14px;
  white-space: nowrap;
}

/* Mobile styles */
@media screen and (max-width: 768px) {
  .waste-table {
    font-size: 14px;
    display: block;
    overflow-x: visible;
    margin: 0;
  }

  .waste-table thead,
  .waste-table tbody,
  .waste-table tr {
    display: block;
    width: 100%;
  }

  .waste-table thead {
    display: none;
  }

  .waste-table tr {
    margin-bottom: 16px;
    margin-left: 0;
    margin-right: 0;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px;
    background: #fff;
  }

  .waste-table td {
    display: block;
    width: 100%;
    border: none;
    padding: 8px 0;
    text-align: left;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .waste-table td::before {
    content: attr(data-label);
    font-weight: bold;
    display: block;
    margin-bottom: 4px;
    color: #666;
  }

  .waste-name-cell::before {
    content: "Вид отхода:";
  }

  .waste-percent-cell::before {
    content: "Процент:";
  }

  .waste-action-cell::before {
    content: "";
  }

  .waste-percent-cell {
    min-width: auto;
  }

  .percent-inputs-wrapper {
    gap: 12px;
  }

  /* Hide range slider on mobile */
  .range-input {
    display: none !important;
  }

  .number-input-group {
    justify-content: flex-start;
  }

  .number-input {
    width: 100%;
    max-width: 140px;
    min-width: 100px;
    padding: 12px 14px;
    font-size: 18px;
    text-align: center;
    box-sizing: border-box;
  }

  .btn-remove {
    width: 100%;
    padding: 10px;
    font-size: 15px;
  }

  .waste-action-cell {
    padding: 8px 0;
  }
}

@media screen and (max-width: 480px) {
  .waste-table {
    font-size: 13px;
  }

  .waste-table tr {
    padding: 10px;
  }

  .number-input {
    width: 100%;
    max-width: 120px;
    min-width: 90px;
    font-size: 17px;
    padding: 10px 12px;
    text-align: center;
    box-sizing: border-box;
  }

  .btn-remove {
    padding: 8px;
    font-size: 14px;
  }
}
</style>